var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7223 19.7227C16.5102 22.9347 11.2886 22.9347 8.07654 19.7227C4.86448 16.5106 4.86448 11.289 8.07654 8.0769C11.2886 4.86484 16.5102 4.86484 19.7223 8.0769C22.9344 11.289 22.9344 16.5106 19.7223 19.7227ZM8.88904 8.88939C6.12655 11.6519 6.12655 16.1477 8.88904 18.9102C11.6515 21.6726 16.1473 21.6726 18.9098 18.9102C21.6723 16.1477 21.6723 11.6519 18.9098 8.88939C16.1473 6.12691 11.6515 6.12691 8.88904 8.88939Z",
    fill: "#00B377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6604 12.9517L12.4104 16.2017C12.1883 16.4237 11.82 16.4237 11.5979 16.2017C11.3758 15.9796 11.3758 15.6112 11.5979 15.3892L14.8479 12.1392C15.07 11.9171 15.4383 11.9171 15.6604 12.1392C15.8825 12.3613 15.8825 12.7296 15.6604 12.9517Z",
    fill: "#00B377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2025 15.6603C16.0995 15.7632 15.9587 15.8282 15.7962 15.8282C15.4821 15.8282 15.2221 15.5682 15.2221 15.254L15.2221 12.5782L12.5462 12.5782C12.2321 12.5782 11.9721 12.3182 11.9721 12.004C11.9721 11.6899 12.2321 11.4299 12.5462 11.4299L15.7962 11.4299C16.1104 11.4299 16.3704 11.6899 16.3704 12.004L16.3704 15.254C16.3704 15.4165 16.3054 15.5573 16.2025 15.6603Z",
    fill: "#00B377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIncreaseIcon);
export default __webpack_public_path__ + "static/media/price-increase-icon.2943b2b5b96a499adc702c56af667655.svg";
export { ForwardRef as ReactComponent };